import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import LoginForm from './components/LoginForm';
import Dashboard from './components/Dashboard';
import LoadingSpinner from './components/LoadingSpinner';

const App: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  // Обработка глобальных ошибок авторизации
  useEffect(() => {
    const handleUnauthorized = () => {
      if (!isAuthenticated && window.location.pathname !== '/login') {
        navigate('/login');
      }
    };

    // Слушаем события storage для синхронизации между вкладками
    window.addEventListener('storage', (e) => {
      if (e.key === 'access_token' && !e.newValue) {
        handleUnauthorized();
      }
    });

    return () => {
      window.removeEventListener('storage', handleUnauthorized);
    };
  }, [isAuthenticated, navigate]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Routes>
      <Route 
        path="/login" 
        element={isAuthenticated ? <Navigate to="/dashboard/admins" /> : <LoginForm />} 
      />
      <Route 
        path="/dashboard/*" 
        element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} 
      />
      <Route 
        path="/" 
        element={<Navigate to={isAuthenticated ? "/dashboard/admins" : "/login"} />} 
      />
    </Routes>
  );
};

export default App; 